import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="#F4EEE6"
      d="M64.5 101.8s-2.8 4.6-2.8 11.7S65 125 65 125s0-6.1 1-9.2 2.8-4.9 2.8-4.9-1.3 4.7.3 10.1c1.5 5.5 4.4 11.3 9.3 13.4 0 0-2-2-2.5-5s-.4-4.8 1-8 3.2-5 3-6.6c0 0 1.1 1.5 1.3 4.6 0 3-1.8 5.2-1.8 5.2s5.1-2.8 7-10.2-1.6-12.5-1.6-12.5H64.4Z"
    />
    <path
      fill="#fff"
      d="M68 101.8s-1.3 2.2-1 6.7c0 0 1.3-4 5.8-5.8 0 0-2 3 .9 12 0 0 5.9-7.7 3.8-11 0 0 2.6.3 4.7 8.5 0 0 .9-2 .5-4.5-.3-2.6-1.5-5.9-1.5-5.9H68Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M41.5 140 7 120.4l34.3-19.8m68.7 39.6 34.2-19.7-34.3-19.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M7.4 110.5 75.7 71l68.7 39.6L76.1 150 7.4 110.4Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M50.4 61.4c-1-.3-3.2 2-4 2.8-3.2 2.7-6 6-8 9.7-2.9 5-4.2 11-3.2 16.7l17-2.4c2.3-.4 4.2-.7 6.4-.3.5.1 4.7 0 4.8.4l-6.2-13.1-5.9-12.3c-.1-.3-.4-1.1-.7-1.4h-.1Zm48.6 1c1.2-.3 3.3 2 4.2 2.8 3.2 2.8 6 6 8 9.7 2.9 5 4.2 11 3.2 16.7l-17.1-2.4c-2.3-.4-4.2-.7-6.5-.3-.5.1-4.6 0-4.8.4 2-4.4 4.2-8.8 6.3-13.1l5.9-12.3c.2-.3.4-1.1.7-1.3l.2-.1Z"
    />
    <path
      fill="#323439"
      fillRule="evenodd"
      d="M59.7 100.3c-1.5-3.5-2.6-6.7-4.2-10.3l34.7.5c.9-.7 2.8.1 3.1-.6-1.3 3.5-2.4 6.8-4 10.3-.4 1.3-1.7 2.5-4 3.5a27.3 27.3 0 0 1-11 1.7c-5.5 0-12.5-1-14.6-5Z"
    />
    <path
      fill="#1b1c1e"
      fillRule="evenodd"
      d="m82.6 90.4 7.6.1c.9-.7 2.8.1 3.1-.6-1.3 3.5-2.4 6.8-4 10.3-.4 1.3-1.7 2.5-4 3.5a27.4 27.4 0 0 1-11 1.7c-5.3 0-12-.9-14.4-4.7 3.4 3.6 14.2 3.8 17.9 2.9 1.7-4.5 3.4-8.9 4.8-13.2Z"
    />
    <path
      fill="#1b1c1e"
      fillRule="evenodd"
      d="M60.7 83.3c7.3-3.1 19.5-3.2 27-.3 7.6 3 7.8 8 .5 11a41.5 41.5 0 0 1-27.1.2c-7.6-3-7.8-7.8-.4-11Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M89.7 20A95.2 95.2 0 0 0 74.8.7S62.8 12.3 58.3 21A84.4 84.4 0 0 0 53 88h.1v.2l.1.3a7 7 0 0 0 .2.5 4 4 0 0 0 .5.8l.3.3a13 13 0 0 0 5.1 3.1 48.6 48.6 0 0 0 30 0c4-1.4 6-3.4 6.2-5.4v-.2C101.8 67 104 43.9 89.7 20Z"
    />
    <path
      fill="#FAF5EF"
      d="M74.8.8s1.9 9.4 4.3 19.8l1.5 6.3v.3c1 4.3 3.6 15.4 4.3 29 .4 6.8.4 15.6-.9 25.9a88.6 88.6 0 0 1-3.3 12c3-.4 5.7-1.1 8-2 3.8-1.5 5.7-3.5 5.9-5.4v-.3c0-1.2.8-2.8 1.1-4a133 133 0 0 0 2.6-13.5 86 86 0 0 0 .4-18.6 84.6 84.6 0 0 0-14-36.8C81.6 8.7 74.9.7 74.9.7Z"
    />
    <path fill="#F4EEE6" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M72.5 78.2v30h5.8v-30h-5.8Z" />
    <path
      fill="#F4EEE6"
      d="M65.5 42.6c-.6-.5-1.7-1.3-3.1-1.8-.5-.2-1-.4-1.8-.4h-1.2.3l-2.7.8S65.2 71 65 71l3-.8.7-.2h.2l1.8-1.3a7.4 7.4 0 0 0 1.8-3.6c1.7-8.2-1.4-15-1.4-15a24 24 0 0 0-5.6-7.6Z"
    />
    <path
      fill="#EDF4F7"
      d="M64.9 45.2c-1.2-1-3.2-2.8-5.4-2.4-2.5.5-3.8 3.6-4.2 5a20 20 0 0 0 4.5 17.6c2 2.1 4.2 3 6.1 2.4 2.8-.7 4-4.2 4.2-4.9.4-1.3.5-2.6.1-4.8-.6-4.6-1.4-9.4-5.3-12.9Z"
    />
    <path
      fill="#F4EEE6"
      d="M61.7 43.5s-6 6-2.3 14.8c3.8 8.8 7.4 9.7 7.4 9.7s-.7 1.7-4.2-.6C59 65.1 53.8 57 54.3 52.5s3.9-9.3 3.9-9.3l1.6-1 1.9 1.3Z"
    />
    <path
      fill="#EDF4F7"
      d="M67 67.6h-2l-.3-.1-.4-.2-.4-.1-.4-.2-.4-.2-.4-.3-.4-.3-.3-.3a5.5 5.5 0 0 1-.8-.7l-.4-.4-.3-.4-.4-.4c0-.2-.2-.3-.3-.5l-.3-.5-.3-.4-.3-.5-.3-.5-.3-.6-.2-.5-.2-.6-.3-.5-.1-.5-.1-.3-.1-.2a22 22 0 0 1-.3-1.1V57l-.1-.4-.2-.6v-.6l-.2-.6v-1.2l-.1-.6v-3l.2-.6V49l.2-.5.1-.6.1-.5.2-.4.2-.5.2-.4a7.5 7.5 0 0 1 .5-.8l.2-.3.2-.3.3-.3.1-.1.2-.2.3-.3h.1l.3-.2h.1l.2-.2h.2l.2-.2h.1l.4-.1-3 .7-.4.2h-.1l-.3.1h-.1l-.2.2h-.2l-.2.3h-.1l-.3.3-.2.2h-.1l-.2.3h-.1l-.1.2h-.1v.2h-.1l-.2.2v.2l-.2.2-.1.2-.1.2-.1.2-.1.2-.1.2v.2h-.1v.2l-.1.2v.1l-.1.1v.2l-.1.2v.2l-.2.2v.7l-.1.2v.1l-.1.1v.7l-.1.2v4.2l.1.1v.7l.1.3v.2l.1.2v.3l.1.1v.3l.1.2v.2l.1.1v.1l.3 1v.1l.1.2.1.3v.2l.2.3.1.3v.2h.1l.1.3.1.3.1.2.2.3v.2l.2.3.1.2.1.2.1.1v.1l.2.3a3.7 3.7 0 0 0 .1.2l.2.2.1.2.2.3.1.2.2.2.1.2.2.2.1.2h.1v.1l.2.3.2.1.1.2.2.1v.1l.1.1.2.1.1.2.2.1.1.2h.1l.2.2.2.1.1.1.2.2h.1l.2.2h.1l.2.2h.2l.2.1.2.1.1.1h.2v.1h.2l.2.1h.1l.1.1h.3l.2.1h2l3-.8H67Z"
    />
    <path
      fill="#fff"
      d="M64.6 43.8c-4.9-5-10.5-3.6-12.4 3-2 6.8.4 16.4 5.4 21.4 4.9 5 10.5 3.7 12.4-3 2-6.8-.4-16.3-5.4-21.4ZM58.2 66c-4-4.2-6-12-4.4-17.4C55.4 43 60 42 64 46c4 4.1 6 11.9 4.4 17.4-1.6 5.5-6.2 6.6-10.2 2.4Z"
    />
    <path fill="#F4EEE6" stroke="#000" strokeWidth={0.4} d="m113.2 111.1-6.4 3.4 7 3.8 6.4-3.4-7-3.8Z" />
    <path fill="none" stroke="#000" strokeWidth={0.4} d="m104 115.6-14.2 7.7 7.3 3.9 14.1-7.7-7.2-4Z" />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeWidth={0.4}
      d="m36.8 113.1-6 3.2 6.6 3.5 6-3.2-6.6-3.5Zm10.1-5-6 3.2 6.5 3.5 6-3.2-6.5-3.5Z"
    />
    <path fill="none" stroke="#000" strokeWidth={0.4} d="m43.4 120.7 13.4 7.5" />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m92.2 24.5-.4-.8a70 70 0 0 0-2-3.7C82.2 7.7 74.7.7 74.7.7S62.8 12.3 58.3 21L57 23.5l-.7 1.4c0 2.8 8 5.1 18 5.1s17.9-2.3 17.9-5.1v-.4Z"
    />
  </svg>
);
